import { isMobile } from 'react-device-detect';
import { useEffect, useState } from 'react';

import { StyledChatContainerNew, StyledChatPageNew } from './ChatPageNew.styled';

import ChatBodyNew from './ChatBodyNew/ChatBodyNew';
import ChatBarNew from './ChatBarNew/ChatBarNew';

export default function ChatPageNew() {
    const [showChatBody, setShowChatBody] = useState(false);
    const [showChatBar, setShowChatBar] = useState(true);
    const [chatGroupId, setChatGroupId] = useState('');
    const [chatTitle, setChatTitle] = useState('');

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const chatGroupIdParam = urlParams.get('ChatGroupId');
        if (chatGroupIdParam) {
            setChatGroupId(chatGroupIdParam);

            // Remove ChatGroupId from URL params
            urlParams.delete('ChatGroupId');
            const newUrl = `${window.location.pathname}${urlParams.toString()}`;
            window.history.replaceState({}, document.title, newUrl);
        }
    }, []);

    useEffect(() => {
        if (!chatGroupId) {
            return;
        }

        if (isMobile) {
            setShowChatBar(false);
        }

        setShowChatBody(true);
    }, [chatGroupId]);

    const handleChatItemClick = (selectedChatGroupId: string, chatName: string) => {
        const url = new URL(window.location.href);
        url.searchParams.delete('ChatGroupId');
        window.history.replaceState({}, document.title, url.toString());
        setChatGroupId(selectedChatGroupId);
        setChatTitle(chatName);
    };

    const handleChatClose = () => {
        setChatGroupId('');
        setShowChatBody(false);
        setShowChatBar(true);
    };

    return (
        <StyledChatPageNew>
            <StyledChatContainerNew>
                {showChatBar && (
                    <ChatBarNew
                        onChatItemClick={handleChatItemClick}
                        activeChatGroupId={chatGroupId}
                    />
                )}
                {showChatBody && (
                    <ChatBodyNew
                        chatGroupId={chatGroupId}
                        chatTitle={chatTitle}
                        handleChatClose={handleChatClose}
                    />
                )}
            </StyledChatContainerNew>
        </StyledChatPageNew>
    );
}
